// keduo --动效 * 4
import keduo_png from "@/assets/game/bird/keduo.png";
import keduo_json from "@/assets/game/bird/keduo.json";
import keduo_atlas from "@/assets/game/bird/keduo.atlas";

// 背景 * 3
import bg_sky_1 from "@/assets/game/background1/bg_Sky_1.jpg";
import bg_sky_2 from "@/assets/game/background1/bg_Sky_2.jpg";
import bg_cloud_1 from "@/assets/game/background1/bg_Cloud_1.png";
import bg_cloud_2 from "@/assets/game/background1/bg_Cloud_2.png";
import bg_seaCity_1 from "@/assets/game/background1/bg_SeaBuilding_1.png";
import bg_seaCity_2 from "@/assets/game/background1/bg_SeaBuilding_2.png";

// 音频 * 7
import bgm_music from "@/assets/game/audio/bg_music1.mp3";
import bgm_flyUp from "@/assets/game/audio/alRight.mp3";
import bgm_win from "@/assets/game/audio/win.mp3";
import bgm_fireworks from "@/assets/game/audio/fireworks_audio.mp3";
import bgm_fail from "@/assets/game/audio/drown_m.mp3";
import bgm_singleRight from "@/assets/game/audio/singleRight.wav";
import bgm_singleWrong from "@/assets/game/audio/singleWrong.mp3";

// 旗子 + 旗杆
import flagbar from "@/assets/game/success/flagbar.png";
import flag from "@/assets/game/success/flag.png";

import loading_png from "@/assets/game/loading/ksy.png";
import loading_json from "@/assets/game/loading/ksy.json";
import loading_atlas from "@/assets/game/loading/ksy.atlas";

export function getGameAssets() {
  return {
    audio: {
      backgroundMusic: bgm_music,
      flyUpSound: bgm_flyUp,
      winSound: bgm_win,
      fireworksSound: bgm_fireworks,
      failSound: bgm_fail,
      singleRightSound: bgm_singleRight,
      singleWrongSound: bgm_singleWrong,
    },
    animations: {
      keduo: {
        image: keduo_png,
        json: keduo_json,
        atlas: keduo_atlas,
      },
      loading: {
        image: loading_png,
        json: loading_json,
        atlas: loading_atlas,
      },
    },
    backgrounds: {
      sky_1: bg_sky_1,
      sky_2: bg_sky_2,
      cloud_1: bg_cloud_1,
      cloud_2: bg_cloud_2,
      seaCity_1: bg_seaCity_1,
      seaCity_2: bg_seaCity_2,
    },
    successFlag: {
      flagpole: flagbar,
      flagImage: flag,
    },
  };
}
